import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  renderPDFPages,
  readPDFFile,
  isPdfFilePasswordCorrect,
  formatBytes,
  readPDFFileAsArrayBuffer,
  readEncryptedPDFFileAsArrayBuffer,
  saveFile,
} from "../Utils";
import LoadingBar from "react-top-loading-bar";
import { PDFDocument } from "pdf-lib-plus-encrypt";
import { rotateRearrangePDFDocument } from "../PDFHelper/PDFRenderer";
import ImageViewerView from "../image_viewer/ImageViewerView";

function RotatePDFImagesListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, index etc key is filepath
  const [pdfInfo, setPdfInfo] = useState({
    state: AppState.NONE,
    pageCount: 0,
    pages: [], //pdf pages object {index, page_no, rotate, flipV, flipH,thumbnail}
    message: "",
    locked: false,
    password: "", //default no password
    name: "---",
    file: null, //selected file
    size: 0, //in bytes
    rotated_blob: null,
    rotated_size: 0,
  });
  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //is rotating
  const [isRotating, setIsRotating] = useState(false);
  //loading bar progress
  const [progress, setProgress] = useState(0);
  //set rotated filename
  const [rotatedFileName, setRotatedFileName] = useState("rotated");

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //selected file
      if (selectedFiles.length > 0) {
        //selected file
        const selectedFile = selectedFiles[0];
        //generate thumbnails
        processPDFFile(selectedFile, pdfInfo.password);
      }

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (
      selectedFiles.length === 0 ||
      (pdfInfo.state === AppState.LOADED && pdfInfo.pages.length === 0)
    ) {
      //reset
      resetScreen();
    }

    //check
    //if locked and password not set
    if (pdfInfo.locked === true && pdfInfo.password === "") {
      //show password field
      setSelectedItemForPasswordInput(selectedFiles[0]);
      //click to focus modal
      document.getElementById("passwordModal").click();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles, pdfInfo]);

  //process pdf file
  const processPDFFile = (file, password) => {
    //generate thumbnails
    generateThumbnails(file, password);
  };

  //generate thumbnails
  const generateThumbnails = async (selectedFile, password) => {
    //check if file encrypted
    //check if given password is correct
    if ((await isPdfFilePasswordCorrect(selectedFile, password)) === true) {
      //read pdf file
      const data = await readPDFFile(selectedFile);

      //page images
      //extract pages as image
      const [images] = await renderPDFPages(
        data,
        password,
        "image/jpeg",
        0.5,
        false,
        false,
        [], //render all pages
        (perct, item, index) => {
          //add to pages
          setPdfInfo({
            ...pdfInfo,
            pages: [
              {
                index: index,
                page_no: index + 1,
                rotate: 0,
                flipV: false,
                flipH: false,
                thumbnail: item,
              },
            ],
            password: password,
            message: "",
            locked: false,
          });
          //set top loading bar progress
          setProgress(perct * 100);
        },
      );

      //set
      //values
      setPdfInfo({
        ...pdfInfo,
        state: AppState.LOADED,
        pageCount: images.length,
        pages: images.map((item, index) => ({
          index: index,
          page_no: index + 1,
          rotate: 0,
          flipV: false,
          flipH: false,
          thumbnail: item,
        })), //pdf pages object {index, page_no, rotate, flipV, flipH thumbnail}
        message: "",
        locked: false,
        password: password,
        name: selectedFile.name,
        file: selectedFile, //selected file
        size: selectedFile.size, //in bytes
        rotated_blob: selectedFile,
        rotated_size: selectedFile.size,
      });
    } else {
      //set
      //values
      setPdfInfo({
        ...pdfInfo,
        state: AppState.NONE,
        pageCount: 0,
        pages: [], //pdf pages object {index, page_no, rotate, flipV, flipH thumbnail}
        message: "PDF is locked.",
        locked: true,
        password: "",
        name: selectedFile.name,
        file: selectedFile, //selected file
        size: selectedFile.size, //in bytes
        rotated_blob: selectedFile,
        rotated_size: selectedFile.size,
      });
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setPdfInfo({
      ...pdfInfo,
      state: AppState.NONE,
      pageCount: 0,
      pages: [], //pdf pages object {index, page_no, rotate, flipV, flipH thumbnail}
      message: "",
      locked: false,
      password: "", //default no password
      name: "---",
      file: null, //selected file
      size: 0, //in bytes
      rotated_blob: null,
      rotated_size: 0,
    });
    setStartProcessingFiles(false);
  };

  //on  filename value changed
  const onFilenameValueChanged = (e) => {
    //set values
    setRotatedFileName(e.target.value);
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf
                  processPDFFile(item, "");
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //process pdf file with password
                  processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    pdfInfo.pages.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //check
          if (pdfInfo.locked === false) {
            //show preview
            setShowImagePreview({
              ...showImagePreview,
              preview: true,
              file: item.thumbnail,
            });
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* rotation button groups */}
          <div
            className="justify-content-center align-items-center text-center btn-group-vertical my-auto"
            data-toggle="buttons"
          >
            {/* rotate clockwise */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //rotate clockwise
                //change angle +90 degree
                setPdfInfo({
                  ...pdfInfo,
                  pages: pdfInfo.pages.map((pg, i) =>
                    i === index ? { ...pg, rotate: pg.rotate + 90 } : pg,
                  ),
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </button>

            {/* Rotate counter clockwise Button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //rotate counter clockwise
                //change angle -90 degree
                setPdfInfo({
                  ...pdfInfo,
                  pages: pdfInfo.pages.map((pg, i) =>
                    i === index ? { ...pg, rotate: pg.rotate - 90 } : pg,
                  ),
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-counterclockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466" />
              </svg>
            </button>

            {/* Flip horizontally button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //flip horizontal
                setPdfInfo({
                  ...pdfInfo,
                  pages: pdfInfo.pages.map((pg, i) =>
                    i === index
                      ? {
                          ...pg,
                          flipH:
                            (pg.rotate / 90) % 2 === 0
                              ? pg.flipH
                                ? false
                                : true
                              : pg.flipH,
                          flipV:
                            (pg.rotate / 90) % 2 !== 0
                              ? pg.flipV
                                ? false
                                : true
                              : pg.flipV,
                        }
                      : pg,
                  ),
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrows"
                viewBox="0 0 16 16"
              >
                <path d="M1.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L2.707 7.5h10.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.293 8.5H2.707l1.147 1.146a.5.5 0 0 1-.708.708z" />
              </svg>
            </button>

            {/* Flip vertically button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //flip vertical
                setPdfInfo({
                  ...pdfInfo,
                  pages: pdfInfo.pages.map((pg, i) =>
                    i === index
                      ? {
                          ...pg,
                          flipH:
                            (pg.rotate / 90) % 2 !== 0
                              ? pg.flipH
                                ? false
                                : true
                              : pg.flipH,
                          flipV:
                            (pg.rotate / 90) % 2 === 0
                              ? pg.flipV
                                ? false
                                : true
                              : pg.flipV,
                        }
                      : pg,
                  ),
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrows-vertical"
                viewBox="0 0 16 16"
              >
                <path d="M8.354 14.854a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.293V2.707L6.354 3.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 2.707v10.586l1.146-1.147a.5.5 0 0 1 .708.708z" />
              </svg>
            </button>
          </div>

          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  item.thumbnail !== null
                    ? URL.createObjectURL(item.thumbnail)
                    : "./images/file_icon.png"
                }
                className="text-center"
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                  transform: `rotate(${item.rotate}deg) scaleX(${
                    item.flipH ? -1 : 1
                  }) scaleY(${item.flipV ? -1 : 1})`,
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">
              Page No: {item.page_no}
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {formatBytes(item.thumbnail !== null ? item.thumbnail.size : 0)}
            </div>
            <div className="d-flex mt-2">
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  pdfInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {pdfInfo.state === AppState.PROCESSED
                  ? "PROCESSED"
                  : "PDF Page"}
              </div>
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                pdfInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {pdfInfo.message}
            </div>
          </div>

          {/* Right side views spinners */}
          {/* Show spinner while processing */}
          {/* Spinner */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                pdfInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-sm-3 ms-2 ${
                pdfInfo.state === AppState.NONE ||
                pdfInfo.state === AppState.LOADED
                  ? ""
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //blur
                  e.currentTarget.blur();
                  //delete page
                  setPdfInfo({
                    ...pdfInfo,
                    pages: pdfInfo.pages.filter((a) => a !== item),
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* Loading Bar */}
      <LoadingBar progress={progress} onLoaderFinished={() => setProgress(0)} />

      {/* show pdf preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Rotate Pdf Pages"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
              data-bs-toggle={`${pdfInfo.locked ? "modal" : ""}`}
              data-bs-target={`${pdfInfo.locked ? "#passwordInputModal" : ""}`}
              id="passwordModal"
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Label filename input */}
              <div>
                <label
                  htmlFor="rotatedFilename"
                  className="form-label mt-5 ms-4 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Output filename"
                >
                  Output filename:
                </label>
                <input
                  type="text"
                  className="form-control ms-4 mt-3 me-4"
                  id="rotatedFilename"
                  aria-describedby="filename"
                  placeholder="Output filename (xyz)"
                  onChange={onFilenameValueChanged}
                  style={{ width: "calc(100% - 48px)" }}
                />
              </div>

              {/* Rotate buttpons */}
              <div className="ms-4 me-4 mt-5">
                <div>
                  <label
                    className="fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Rotate all pages"
                  >
                    Quick Actions:
                  </label>
                </div>

                {/* All pages rotation button */}
                <div className="d-flex mt-4">
                  <button
                    className="btn btn-outline-primary"
                    onClick={(e) => {
                      //rotate all pages
                      //cw
                      setPdfInfo({
                        ...pdfInfo,
                        pages: pdfInfo.pages.map((pg, i) => ({
                          ...pg,
                          rotate: pg.rotate + 90,
                        })),
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-clockwise me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Rotate Clockwise
                    </label>
                  </button>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={(e) => {
                      //rotate all pages
                      //ccw
                      setPdfInfo({
                        ...pdfInfo,
                        pages: pdfInfo.pages.map((pg, i) => ({
                          ...pg,
                          rotate: pg.rotate - 90,
                        })),
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-counterclockwise me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Rotate Counter Clockwise
                    </label>
                  </button>
                </div>

                {/* All pages flip button */}
                <div className="d-flex mt-2">
                  <button
                    className="btn btn-outline-primary"
                    onClick={(e) => {
                      //flip all pages
                      //fliph
                      setPdfInfo({
                        ...pdfInfo,
                        pages: pdfInfo.pages.map((pg, i) => ({
                          ...pg,
                          flipH:
                            (pg.rotate / 90) % 2 === 0 //change flip axis when rotation changed
                              ? pg.flipH
                                ? false
                                : true
                              : pg.flipH,
                          flipV:
                            (pg.rotate / 90) % 2 !== 0 //change flip axis when rotation changed
                              ? pg.flipV
                                ? false
                                : true
                              : pg.flipV,
                        })),
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrows me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L2.707 7.5h10.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.293 8.5H2.707l1.147 1.146a.5.5 0 0 1-.708.708z" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Flip Horizontal
                    </label>
                  </button>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={(e) => {
                      //flip all pages
                      //flipv
                      setPdfInfo({
                        ...pdfInfo,
                        pages: pdfInfo.pages.map((pg, i) => ({
                          ...pg,
                          flipH:
                            (pg.rotate / 90) % 2 !== 0 //change flip axis when rotation changed
                              ? pg.flipH
                                ? false
                                : true
                              : pg.flipH,
                          flipV:
                            (pg.rotate / 90) % 2 === 0 //change flip axis when rotation changed
                              ? pg.flipV
                                ? false
                                : true
                              : pg.flipV,
                        })),
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrows-vertical me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.354 14.854a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.293V2.707L6.354 3.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 2.707v10.586l1.146-1.147a.5.5 0 0 1 .708.708z" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Flip Vertical
                    </label>
                  </button>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isRotating ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                  lineHeight: "1.1",
                }}
                type="button"
                onClick={async (e) => {
                  //blur
                  e.currentTarget.blur();
                  //check
                  //if indices not defined
                  //return
                  if (selectedFiles.length === 0) {
                    //return
                    return;
                  }
                  //set
                  setIsRotating(true);
                  //try catch
                  try {
                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Reading file...`,
                    });

                    //read pdf file
                    let data = await readPDFFileAsArrayBuffer(selectedFiles[0]);
                    // Load a PDF with form fields
                    //if encrypted
                    //proceed to ctch block
                    const pdfDoc = await PDFDocument.load(data);

                    //set
                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Processing file...`,
                    });

                    //rotate file
                    await rotateRearrangePDFDocument(
                      "Rotated PDF",
                      pdfDoc,
                      pdfInfo.pages,
                      pdfInfo.password,
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Processing file ${Math.floor(
                            perct * 100,
                          )}% ...`,
                        });
                      },
                      (blob) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSED,
                          message: `Successfully rotated pdf pages. New pdf file will be downloaded automatically on your device.`,
                          rotated_blob: blob === null ? selectedFiles[0] : blob,
                          rotated_size:
                            blob === null ? selectedFiles[0].size : blob.size,
                        });

                        //check
                        if (blob !== null) {
                          //save file
                          saveFile(blob, rotatedFileName + ".pdf");
                        }
                      },
                    );
                  } catch {
                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Reading file...`,
                    });

                    //read pdf file
                    let data = await readEncryptedPDFFileAsArrayBuffer(
                      selectedFiles[0],
                      pdfInfo.password,
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Extracted ${Math.floor(perct * 100)}%`,
                        });
                      },
                    );

                    //check
                    if (data === null) {
                      //set
                      //set blob
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSED,
                        message: `Failed processing file.`,
                      });
                      //cotinue
                      return;
                    }
                    // Load a PDF with form fields
                    //if encrypted
                    //proceed to ctch block
                    const pdfDoc = await PDFDocument.load(data);

                    //set
                    //set state
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSING,
                      message: `Processing file...`,
                    });

                    //rotate file
                    await rotateRearrangePDFDocument(
                      "Rotated PDF",
                      pdfDoc,
                      pdfInfo.pages,
                      pdfInfo.password,
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Processing file ${Math.floor(
                            perct * 100,
                          )}% ...`,
                        });
                      },
                      (blob) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSED,
                          message: `Successfully rotated pdf pages. New pdf file will be downloaded automatically on your device.`,
                          rotated_blob: blob === null ? selectedFiles[0] : blob,
                          rotated_size:
                            blob === null ? selectedFiles[0].size : blob.size,
                        });

                        //check
                        if (blob !== null) {
                          //save file
                          saveFile(blob, rotatedFileName + ".pdf");
                        }
                      },
                    );
                  }
                  //reset
                  setIsRotating(false);
                }}
              >
                ROTATE <br />
                <span className="fs-6">Save rotated pages</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  );
}

export default RotatePDFImagesListScreen;
